/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const explain_share_body = () => `Willst du ein Ticket mit einer Freundin oder einem Freund teilen? Das geht in wenigen Klicks. Du kannst das Ticket direkt übertragen oder die andere Person erst bezahlen lassen — der Betrag wird dir dann automatisch zurückerstattet.`
